"use strict";

var Backbone                = require("backbone");
var $                       = require("jquery");
var _                       = require("underscore");
Backbone.$                  = $;

var template                = require("../templates/annotation-template.html");

var debug                   = require("debug")("views:AnnotationView");


// AnnotationView : affiche une annotation dans la page
module.exports = Backbone.View.extend({

    template:_.template(template), // compile template
    model:null,         // AnnotationModel
    className:"annotation",

    events:{
        "pointerdown":"onDragPinStart"   
    },
    
    /**
     */
    initialize:function(options){
        var T=this;
        
        T._pointers={};
        T._dragStartPoint={x:0,y:0};
        T._dragStartSelection={};
        T._abortDrag=false;

        _.extend(T, options);

        T.listenTo(T.model, "change", T.render);
        T.listenTo(T.model, "destroy", T.remove);
    },

    render: function(){
        
        var T=this,
            context=T.model.toJSON();

        T.$el.html(T.template(context));
        T.$el.css({
            top:T.model.get("top")+"%",
            left:T.model.get("left")+"%"
        });
        return T;
    },

    onDragPinStart:function(e){
        var T=this;

        e.preventDefault();
        e.stopPropagation();

        T._pointers[e.originalEvent.pointerId]={
            pageX:e.pageX,
            pageY:e.pageY
        };

        var keys=_.keys(T._pointers);

        if(keys.length==1){
            T.dragStartDate=Date.now();
            T._dragStartPoint.x=e.pageX;
            T._dragStartPoint.y=e.pageY;
            $(window).on("pointermove.annotation",function(e){T.onDragPinMove(e);});
            $(window).on("pointerup.annotation",function(e){T.onDragPinEnd(e);});
            $(window).on("pointercancel.annotation",function(e){T.onDragPinEnd(e);});
        }
        else{
            T._abortDrag=true;
        }

    },

    onDragPinMove:function(e){ //jshint ignore: line
        var T=this;

        if(T._abortDrag)return;

        //console.log("drag move doc "+e.type);
        T._pointers[e.originalEvent.pointerId]={
            pageX:e.pageX,
            pageY:e.pageY
        };

        var keys=_.keys(T._pointers);
        if(keys.length==1){
            var container_width=T.$el.parent().parent().width();
            var container_height=T.$el.parent().parent().height();

            var dX=(e.pageX-T._dragStartPoint.x)*100/container_width, // %
                dY=(e.pageY-T._dragStartPoint.y)*100/container_height; // %

            //console.log("dx: "+dX);

            var new_x=T.model.get("left")+dX;
            var new_y=T.model.get("top")+dY;

            // clamp
            if(new_x<0){
                new_x=0;
            }
            else if(new_x>100){
                new_x=100;
            }
            if(new_y<0){
                new_y=0;
            }
            else if(new_y>100){
                new_y=100;
            }

            T.dragPinX=new_x;
            T.dragPinY=new_y;

            T.$el.css({
                top:new_y+"%",
                left:new_x+"%"
            });       
        }

    },

    onDragPinEnd:function(e){
        var T=this;
        var last_x=T._pointers[e.originalEvent.pointerId].pageX;
        var last_y=T._pointers[e.originalEvent.pointerId].pageY;
        
        delete T._pointers[e.originalEvent.pointerId];

        var keys=_.keys(T._pointers);

        //console.log("drag end doc "+e.type);
        if(!keys.length){
            $(window).off(".annotation");
            T._abortDrag=false;

            if(Date.now()-T.dragStartDate<400 && Math.abs(last_x-T._dragStartPoint.x)<3&& Math.abs(last_y-T._dragStartPoint.y)<3){
                // c'est un click
                debug("click");
                T.trigger("click",T.model);
            }
            else{
                // c'est un déplacement on affecte la valeur à l'annotation
                T.model.save({
                    top:T.dragPinY,
                    left:T.dragPinX
                },{
                    error: function(){ 
                        T.app.notify({
                            text:STR.unable_to_save,
                            type:"error",
                            timeout:4000
                        });
                    }
                });
            }
        }
    },

    close: function(){
        var T=this;
        T.stopListening();
        T.undelegateEvents();
    }

});